import * as React from "react";
import { forwardRef } from "react";
const SvgIconManualInteraction = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 12, height: 12, "data-name": "icon/manualinteraction", viewBox: "0 0 12 12", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 6, cy: 6, r: 6, "data-name": "Ellipse 601", fill: "#b6c2d0" }), /* @__PURE__ */ React.createElement("path", { d: "M6.585.272H5.458V-2.7L3.942.213H3.19L1.666-2.7V.272H.525v-5.508h1.009l2.032 3.785 2.018-3.785h1z", transform: "translate(2.433 8.526)", fill: "#fff" }));
const ForwardRef = forwardRef(SvgIconManualInteraction);
export { ForwardRef as ReactComponent };
